export const FOLLOW_USER = `
  mutation followUser($id: ID!) {
    followUser(id: $id) {
      id
    }
  }
`;

export const UNFOLLOW_USER = `
  mutation unFollowUser($id: ID!) {
    unFollowUser(id: $id)
  }
`;
